import { getLocale } from '../utils/i18nUtils';
import { getEnvironment } from '../utils/platform';
import { getRange } from '../utils/queryUtils';
import { getDexfApiKey } from './dexfApiKey';
import { getDexfSettingsFilterSegment } from './dexfSettingsService';
import { getTranslationEndpoints } from './translationEndpoints';
export const getKompisSettingsApplicationName = () => `storageone${getRange()}`;
export const getKompisSettings = (dexfSettings) => ({
    consumer: 'StorageOne',
    contract: '42079',
    locale: getLocale(),
    applicationName: getKompisSettingsApplicationName(), // used by VPC
    applicationNameTranslated: '',
    translationEndpointApplication: 'storageone',
    translationPrefixApplication: getRange(),
    dexfApplicationId: getKompisSettingsApplicationName(), // storageonepax, storageonebesta
    uiPlatform: 'oneweb',
    environment: getEnvironment(),
    dexfApiKey: getDexfApiKey(getRange()),
    translationEndpoints: getTranslationEndpoints(getLocale()),
    filterSegment: getDexfSettingsFilterSegment(),
    settings: dexfSettings
});
//# sourceMappingURL=kompisSettings.js.map